// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2, h3 {
  text-align: center;
}

.font {
  background-color: #000215;
  color: #fefcf9;
  width: 100%;
  height: 100%;
  border: 1px solid rgb(0, 0, 0);
  overflow: auto;
}

.date {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000215;
  color: #fefcf9;
  height: 50px;
  font-style: italic;
  margin-bottom: 0;
}

.headerBand {
  display: flex;
  flex: 2;
  width: 100%;
  min-width: max-content;
  grid-template-columns: 2fr 4fr 2fr;
  -moz-column-gap: 2px;
       column-gap: 2px;
  margin-bottom: 50px;
}

.road-team,
.home-team {
  display: flex;
  justify-content: center;
}
.road-team .roadTeamName,
.road-team .homeTeamName,
.home-team .roadTeamName,
.home-team .homeTeamName {
  margin-right: 10px;
}

.teamHeaders {
  flex-direction: column;
  display: flex;
  flex: 1;
  font-size: 17px;
  justify-content: center;
  font-weight: bold;
  height: -moz-fit-content;
  height: fit-content;
  padding-bottom: 10px;
  padding-top: 10px;
  border-radius: 8px;
  box-shadow: 5px 5px 8px #c4c5ea;
  margin-bottom: 10px;
}

.road-team-info,
.home-team-info {
  display: flex;
  flex-direction: row;
  flex: 5;
}

.roadBand,
.homeBand {
  padding: 10px;
  flex: 1;
  text-align: left;
  line-height: normal;
  display: flex;
  justify-content: center;
  flex-direction: column;
  white-space: nowrap;
}
.roadBand .band-title,
.homeBand .band-title {
  align-items: center;
  color: rgb(211, 253, 253);
}
.roadBand div,
.homeBand div {
  text-align: center;
}

.homeTeamName,
.roadTeamName {
  font-size: 27px;
  font-style: italic;
}

.scoreRoad,
.scoreHome {
  flex: 1;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
  font-size: 35px;
}

.last-five {
  padding: 10px;
  flex: 3;
}

.generalDiv {
  background-color: rgb(211, 253, 253);
  box-shadow: 5px 5px 8px #c4c5ea;
  color: white;
}

.simulation {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.statsAnalyser {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.statsRows {
  display: flex;
  justify-content: center;
  border: 2px solid white;
  height: 100px;
  width: 80%;
}

.roster {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

app-main-roster {
  display: flex;
  justify-content: center;
}

app-last-opposition {
  display: flex;
  justify-content: center;
  width: 50%;
  margin: 50px auto;
}

.lineup {
  display: grid;
  grid-template-columns: 1fr;
  margin: 50px 2%;
  border-radius: 2em;
  height: auto;
  background-color: rgb(211, 253, 253);
  box-shadow: 5px 5px 8px #c4c5ea;
  width: 95%;
  color: white;
  text-align: center;
}

.space {
  padding-bottom: 20px;
}

.home-road-specific-stats {
  display: flex;
  flex: 12;
  flex-direction: row;
}
.home-road-specific-stats .road-specific,
.home-road-specific-stats .home-specific {
  display: flex;
  flex: 3;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
}
.home-road-specific-stats .road-specific .last-five,
.home-road-specific-stats .home-specific .last-five {
  font-weight: bold;
}
.home-road-specific-stats app-stats-analyser {
  flex: 6;
}

.font-table {
  display: flex;
  justify-content: center;
  border-radius: 8px;
  height: auto;
  box-shadow: 5px 5px 8px #c4c5ea;
  background-color: rgb(211, 253, 253);
  padding: 15px;
  width: 70%;
}

td {
  display: column;
  border: 3px solid rgb(10, 9, 9);
  text-align: center;
  color: #000;
  font-size: 0.8rem;
}

table {
  border-collapse: collapse;
}

.header,
th {
  font-weight: bold;
  text-align: center;
  font-size: 14px;
  border: 4px solid rgb(10, 9, 9);
  color: #000;
}

@media only screen and (max-width: 600px) {
  /* For mobile phones: */
  .date {
    font-size: 15px;
  }
  .road-team,
  .home-team {
    display: flex;
    justify-content: center;
  }
  .road-team .roadTeamName,
  .road-team .homeTeamName,
  .home-team .roadTeamName,
  .home-team .homeTeamName {
    margin-right: 10px;
    font-size: 15px;
  }
  .road-team-info,
  .home-team-info {
    font-size: 10px;
  }
  .last-five h2 {
    font-size: 11px !important;
  }
  .headerBand {
    width: 1200px;
  }
  .home-road-specific-stats {
    width: 1200px;
  }
  .road-specific {
    font-size: 10px;
  }
  th {
    font-size: 9px;
  }
  td {
    font-size: 7px;
  }
  app-main-roster {
    width: 1200px;
  }
  app-last-opposition {
    width: 1200px;
  }
  .rosterRoad {
    margin-right: 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/accueil/accueil.component.scss","webpack://./src/utilities/variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;;AAIA;EACE,yBCPY;EDQZ,cAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBCnBY;EDoBZ,cAAA;EACA,YChBc;EDiBd,kBAAA;EACA,gBAAA;AADF;;AAMA;EACE,aAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,kCAAA;EACA,oBAAA;OAAA,eAAA;EACA,mBAAA;AAHF;;AAMA;;EAEE,aAAA;EACA,uBAAA;AAHF;AAKE;;;;EAEE,kBAAA;AADJ;;AAKA;EACE,sBAAA;EACA,aAAA;EACA,OAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,oBAAA;EACA,iBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,mBAAA;AAHF;;AAMA;;EAEE,aAAA;EACA,mBAAA;EACA,OAAA;AAHF;;AAMA;;EAEE,aAAA;EACA,OAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAHF;AAKE;;EACE,mBAAA;EACA,yBAAA;AAFJ;AAKE;;EACE,kBAAA;AAFJ;;AAMA;;EAEE,eAAA;EACA,kBAAA;AAHF;;AAMA;;EAEE,OAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AAHF;;AAMA;EACE,aAAA;EACA,OAAA;AAHF;;AAMA;EACE,oCAAA;EACA,+BAAA;EACA,YAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBAAA;AAJF;;AAmBA;EACE,aAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,+BAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;AAhBF;;AAoBA;EACE,oBAAA;AAjBF;;AAiCA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AA9BF;AAgCE;;EAEE,aAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,uBAAA;AA9BJ;AAgCI;;EACE,iBAAA;AA7BN;AAiCE;EACE,OAAA;AA/BJ;;AAmCA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,oCAAA;EACA,aAAA;EACA,UAAA;AAhCF;;AAoCA;EACE,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAjCF;;AAoCA;EACE,yBAAA;AAjCF;;AAoCA;;EAEE,iBAAA;EACA,kBAAA;EACA,eAAA;EAEA,+BAAA;EACA,WAAA;AAlCF;;AAsCA;EAEE,uBAAA;EACA;IACE,eAAA;EApCF;EAuCA;;IAEE,aAAA;IACA,uBAAA;EArCF;EAuCE;;;;IAEE,kBAAA;IACA,eAAA;EAnCJ;EAuCA;;IAEE,eAAA;EArCF;EAyCE;IAEE,0BAAA;EAxCJ;EA4CA;IACE,aAAA;EA1CF;EA4CA;IACE,aAAA;EA1CF;EA6CA;IACE,eAAA;EA3CF;EA8CA;IACE,cAAA;EA5CF;EA+CA;IACE,cAAA;EA7CF;EAgDA;IACE,aAAA;EA9CF;EAiDA;IACE,aAAA;EA/CF;EAmDD;IACC,6BAAA;EAjDA;AACF","sourcesContent":["@import \"/src/utilities/variables\";\r\n\r\nh2, h3  {\r\n  text-align: center;\r\n}\r\n\r\n.font {\r\n  background-color: $color_black;\r\n  color: #fefcf9;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 1px solid rgb(0, 0, 0);\r\n  overflow: auto;\r\n}\r\n\r\n.date {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: $color_black;\r\n  color: #fefcf9;\r\n  height: $header_height;\r\n  font-style: italic;\r\n  margin-bottom: 0;\r\n}\r\n\r\n\r\n\r\n.headerBand {\r\n  display: flex;\r\n  flex: 2;\r\n  width: 100%;\r\n  min-width: max-content;\r\n  grid-template-columns: 2fr 4fr 2fr;\r\n  column-gap: 2px;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.road-team,\r\n.home-team {\r\n  display: flex;\r\n  justify-content: center;\r\n\r\n  .roadTeamName,\r\n  .homeTeamName {\r\n    margin-right: 10px;\r\n  }\r\n}\r\n\r\n.teamHeaders {\r\n  flex-direction: column;\r\n  display: flex;\r\n  flex: 1;\r\n  font-size: 17px;\r\n  justify-content: center;\r\n  font-weight: bold;\r\n  height: fit-content;\r\n  padding-bottom: 10px;\r\n  padding-top: 10px;\r\n  // border: 6px solid #81c0e4;\r\n  border-radius: 8px;\r\n  box-shadow: 5px 5px 8px #c4c5ea;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.road-team-info,\r\n.home-team-info {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex: 5;\r\n}\r\n\r\n.roadBand,\r\n.homeBand {\r\n  padding: 10px;\r\n  flex: 1;\r\n  text-align: left;\r\n  line-height: normal;\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  white-space: nowrap;\r\n\r\n  .band-title {\r\n    align-items: center;\r\n    color: rgb(211, 253, 253);\r\n  }\r\n\r\n  div {\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.homeTeamName,\r\n.roadTeamName {\r\n  font-size: 27px;\r\n  font-style: italic;\r\n}\r\n\r\n.scoreRoad,\r\n.scoreHome {\r\n  flex: 1;\r\n  padding: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 30%;\r\n  font-size: 35px;\r\n}\r\n\r\n.last-five {\r\n  padding: 10px;\r\n  flex: 3;\r\n}\r\n\r\n.generalDiv {\r\n  background-color: rgb(211, 253, 253);\r\n  box-shadow: 5px 5px 8px #c4c5ea;\r\n  color: white;\r\n}\r\n\r\n.simulation {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.statsAnalyser {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.statsRows {\r\n  display: flex;\r\n  justify-content: center;\r\n  border: 2px solid white;\r\n  height: 100px;\r\n  width: 80%;\r\n}\r\n\r\n.roster {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\napp-main-roster {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\napp-last-opposition {\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 50%;\r\n  // width: fit-content;\r\n  margin: 50px auto ;\r\n}\r\n\r\n// .trelloRoad,\r\n// .trelloHome {\r\n//   margin: 25px 2%;\r\n//   background-color: rgb(211, 253, 253);\r\n//   box-shadow: 5px 5px 8px #c4c5ea;\r\n//   border-radius: 2em;\r\n//   height: 500px;\r\n//   width: 90%;\r\n//   color: black;\r\n//   text-align: center;\r\n// }\r\n\r\n.lineup {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  margin: 50px 2%;\r\n  border-radius: 2em;\r\n  height: auto;\r\n  background-color: rgb(211, 253, 253);\r\n  box-shadow: 5px 5px 8px #c4c5ea;\r\n  width: 95%;\r\n  color: white;\r\n  text-align: center;\r\n  // padding-bottom: 20px ;\r\n}\r\n\r\n.space {\r\n  padding-bottom: 20px;\r\n}\r\n\r\n// .trelloHome {\r\n//   margin-top: 50px;\r\n//   margin-right: 100px;\r\n//   background-color:rgb(241, 144, 16);\r\n//   height: 400px;\r\n//   width: 40%;\r\n//   color: white;\r\n// }\r\n\r\n// a {\r\n//   color: white;\r\n//   text-decoration: none;\r\n// }\r\n.home-road-specific-stats {\r\n  display: flex;\r\n  flex: 12;\r\n  flex-direction: row;\r\n\r\n  .road-specific,\r\n  .home-specific {\r\n    display: flex;\r\n    flex: 3;\r\n    width: 100%;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n\r\n    .last-five {\r\n      font-weight: bold;\r\n    }\r\n  }\r\n\r\n  app-stats-analyser {\r\n    flex: 6;\r\n  }\r\n}\r\n\r\n.font-table {\r\n  display: flex;\r\n  justify-content: center;\r\n  border-radius: 8px;\r\n  height: auto;\r\n  box-shadow: 5px 5px 8px #c4c5ea;\r\n  background-color: rgb(211, 253, 253);\r\n  padding: 15px;\r\n  width: 70%;\r\n\r\n}\r\n\r\ntd {\r\n  display: column;\r\n  border: 3px solid rgb(10, 9, 9);\r\n  text-align: center;\r\n  color: #000;\r\n  font-size: 0.8rem;\r\n}\r\n\r\ntable {\r\n  border-collapse: collapse;\r\n}\r\n\r\n.header,\r\nth {\r\n  font-weight: bold;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  // width: fit-content;\r\n  border: 4px solid rgb(10, 9, 9);\r\n  color: #000;\r\n\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n\r\n  /* For mobile phones: */\r\n  .date {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .road-team,\r\n  .home-team {\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    .roadTeamName,\r\n    .homeTeamName {\r\n      margin-right: 10px;\r\n      font-size: 15px;\r\n    }\r\n  }\r\n\r\n  .road-team-info,\r\n  .home-team-info {\r\n    font-size: 10px;\r\n  }\r\n\r\n  .last-five {\r\n    h2 {\r\n\r\n      font-size: 11px !important;\r\n    }\r\n  }\r\n\r\n  .headerBand {\r\n    width: 1200px;\r\n  }\r\n  .home-road-specific-stats {\r\n    width: 1200px;\r\n  }\r\n\r\n  .road-specific {\r\n    font-size: 10px;\r\n  }\r\n\r\n  th {\r\n    font-size: 9px;\r\n  }\r\n\r\n  td {\r\n    font-size: 7px;\r\n  }\r\n\r\n  app-main-roster {\r\n    width: 1200px;\r\n  }\r\n\r\n  app-last-opposition {\r\n    width: 1200px;\r\n  }\r\n\r\n\r\n .rosterRoad {\r\n  margin-right: 20px !important;\r\n }\r\n\r\n}\r\n","$color_black: #000215;\r\n$color_dark_blue: #011d44;\r\n$color_light_blue: #81c0e4;\r\n$color_purple: #c4c5ea;\r\n$color_white: #fefcf9;\r\n$header_height: 50px;\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
